import {RPCService} from '../service/rpc-service';
import {createContext, useContext} from 'react';

export type RPCContextType = [RPCService, boolean, number];

export const RPCContext = createContext<RPCContextType>(null);

export const useRPC = () => useContext<RPCContextType>(RPCContext);
